export function groupBookingItems(items) {
  const grouped = new Map();

  for (const item of items) {
    const key = `${item.product_type_id}_${item.size || ''}`;

    if (grouped.has(key)) {
      const existing = grouped.get(key);
      existing.quantity += (item.quantity || 1);
      existing.total_price += parseFloat(item.total_price || 0);
      existing.sourceItems.push(item);
    } else {
      grouped.set(key, {
        ...item,
        quantity: item.quantity || 1,
        total_price: parseFloat(item.total_price || 0),
        sourceItems: [item],
        groupKey: key
      });
    }
  }

  return Array.from(grouped.values());
}
